import { LayoutGray } from "@/components/LayoutGray";
import { MainButton } from "@/components/ui-components/MainButton";
import { buttonVariants } from "@/components/ui-components/MainButton/buttonVariants";

import styles from "./Custom404Page.module.scss";

const Custom404Page = () => {
  return (
    <LayoutGray isCartButton isProfileButton>
      <div className={styles.root}>
        <div className={styles.title}>
          <span>Такой страницы не существует</span>
        </div>

        <MainButton
          className={styles.button}
          variant={buttonVariants.BRIGHTWHITE}
          href="/"
        >
          На главную
        </MainButton>
      </div>
    </LayoutGray>
  );
};

export default Custom404Page;
